module.exports = __webpack_public_path__ + "static/slide4-ff4a768ab4d2ffaaf91f3593308957fe.png";